import { FC, useMemo } from 'react';
import cn from 'classnames';
import type { DataTableRow } from '@/components/UI/DataTableV2/DataTable.model';
import styles from '@/components/UI/DataTableV2/DataTableV2.module.scss';

interface LivingStatusRowHeaderProps {
  row: DataTableRow | undefined;
}

export const LivingStatusRowHeader: FC<LivingStatusRowHeaderProps> = ({ row }) => {
  const status = useMemo(() => {
    const terminated_at = row?.animal?.terminated_at;
    if (terminated_at === null) {
      return 'alive';
    }
    if (typeof terminated_at === 'string') {
      return 'deceased';
    }
    return 'unknown';
  }, [row?.animal?.terminated_at]);
  if (status === 'alive') {
    return (
      <div className={styles.livingStatusContainer}>
        <span className={cn(styles.livingStatusChip, styles.alive)}>Alive</span>
      </div>
    );
  } else if (status === 'deceased') {
    return (
      <div className={styles.livingStatusContainer}>
        <span className={cn(styles.livingStatusChip, styles.deceased)}>Deceased</span>
      </div>
    );
  }
  return null;
};
